import React from 'react';

import { ThankYouStyles } from './ThankYou.styled';
import { getTradeDeskIframe } from '@utils/config';

const ThankYou = () => {
  return (
    <ThankYouStyles>
      <h5 className="heading">Message sent!</h5>
      <p>A team member will reach out to you as soon as&nbsp;possible.</p>
      {getTradeDeskIframe()}
    </ThankYouStyles>
  );
};

export default ThankYou;
